export const RECIPIENTS = {
  concierge: "hi@snackmagic.com",
  purchasing: "purchasing@snackmagic.com",
  brands: "brands@snackmagic.com",
  restaurants: "restaurants@snackmagic.com",
  shops: "hi@bystadium.com",
};

export const SWAGMAGIC_CONCIERGE = "hi@swagmagic.com";
export const SWAGMAGIC_CONCIERGE_2 = "swag@snackmagic.com";

export const DONATION = "donations@snackmagic.com";
